const spark = {
    namespaced: true,

    state: {
        tier: null,
        tierInfo: null,
        tierLoaded: false,
        tierSubscribed: false  // false = 402 (no subscription), true = has tier
    },

    mutations: {
        SET_TIER(state, tier) {
            state.tier = tier
        },
        SET_TIER_INFO(state, tierInfo) {
            state.tierInfo = tierInfo
            state.tierLoaded = true
            state.tierSubscribed = tierInfo !== null
        }
    },

    actions: {
        loadTier({ commit }) {
            return this._vm.$sandbox.spark().tier().then(resp => {
                if (resp && resp.data) {
                    commit('SET_TIER_INFO', resp.data)
                    commit('SET_TIER', resp.data.tier || null)
                }
                return resp
            }).catch(err => {
                const status = err && err.response && err.response.status
                if (status === 402) {
                    // No active subscription — tier exists as concept but not purchased
                    commit('SET_TIER_INFO', null)
                } else {
                    // Other error — mark loaded so UI doesn't stay blocked
                    commit('SET_TIER_INFO', null)
                }
            })
        }
    },

    getters: {
        sparkTier(state) {
            return state.tier
        },

        tierLoaded(state) {
            return state.tierLoaded
        },

        tierSubscribed(state) {
            return state.tierSubscribed
        },

        canCreateSpark(state) {
            if (!state.tierLoaded) return false
            if (!state.tierSubscribed || !state.tierInfo) return false
            return state.tierInfo.current_spark_count < state.tierInfo.max_sparks
        },

        sparkQuotaInfo(state) {
            return state.tierInfo
        }
    }
}

export default spark
